//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { mapActions } from "vuex";

export default {
    name: "ValidateCode",
    components: {
        AQInput,
        AQButton
    },
    props: {
        title: { type: String, default: "" },
        value: { type: Boolean, default: false },
        errorData: { type: Object, default: () => {} },
        twoFactorId: { type: String, default: "" }

    },
    data() {
        return {
            accessCode: "",
            newAccessCodeRequested: false,
            accessCodeEmpty: false,
            wrongAccessCode: false,
            expiredAccessCode: false,
            countDown: 60
        };
    },
    computed: {
        accessCodeValidator() {
            let errorMsg = "";
            if (this.wrongAccessCode) {
                errorMsg = this.$t("login.wrongAccessCode");
            } else if (this.accessCodeEmpty) {
                errorMsg = this.$t("login.emptyAccessCode");
            } else if (this.expiredAccessCode) {
                errorMsg = this.$t("login.expiredAccessCode");
            }
            return errorMsg;
        }
    },
    created() {
        this.newAccessCodeRequested = true;
        this.countDownTimer();
    },
    methods: {
        ...mapActions("admin", ["generateCode"]),
        setValue(show) {
            this.$emit("input", show);
        },
        checkCode() {
            this.$emit("validateAccessCode", this.accessCode);
            setTimeout(() => {
                if (!this.accessCode) {
                    this.accessCodeEmpty = true;
                } else if (this.errorData && this.errorData.error === "Invalid authentication code") {
                    this.wrongAccessCode = true;
                } else if (this.errorData
                    && this.errorData.error === "Your authentication code has expired. Please generate a new authentication code") {
                    this.expiredAccessCode = true;
                } else {
                    this.setValue(false);
                }
            }, 500);
        },
        generateNewAccessCode() {
            this.generateCode({ twoFactorId: this.twoFactorId }).then(() => {
                this.countDown = 60;
                this.newAccessCodeRequested = true;
                this.countDownTimer();
            }).catch(() => {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$i18n.t("login.errorGenerate")
                });
            });
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.countDownTimer();
                }, 1000);
            } else {
                this.newAccessCodeRequested = false;
            }
        },
        removeAccessCodeErrors() {
            this.wrongAccessCode = false;
            this.expiredAccessCode = false;
            this.accessCodeEmpty = false;
        }
    }
};

